import { Component } from '@angular/core';

@Component({
  selector: 'em-element-log',
  templateUrl: './element-log.component.html',
  standalone: false,
})
export class ElementLogComponent {}
